import { axiosInstance } from "../axios";

// 话查询用户信息
export function fetchGetAllUserInfoByCell(params) {
    // return axiosInstance.get('/ark/common/getAllUserInfoByCell', { params })
    return axiosInstance.get('/ark/arkservice/common/getAllUserInfoByCell', { params })
}

// 按照ticketID获取工单信息
export function fetchTicketById(params) {
    // return axiosInstance.get('/ark/ticket/findTicketById', { params })
    return axiosInstance.get('/ark/arkservice/ticket/findTicketById', { params })
}

// 根据业务线 身份获取问题分类
export function findCategory(params) {
    // return axiosInstance.get('/ark/common/findCategory', { params })
    return axiosInstance.get('/ark/arkservice/common/findCategory', { params })
}

// 获取订单详情
export function fetchGetOrderinfo(params) {
    return axiosInstance.get('/ark/arkservice/common/getOrderInfo', { params })
}

// 获取订单列表
export function fetchGetOrderList(params) {
    // return axiosInstance.get('/ark/common/getOrderListV2', { params })
    return axiosInstance.get('/ark/arkservice/common/getOrderList', { params })
}

export function fetchUpdateTicket(params) {
    return axiosInstance.post('/ark/arkservice/ticket/updateTicket', params)
}

// 获取邮箱模版内容 /ark/email_template/getContent
export function fetchGetContent(params) {
    return axiosInstance.get('/ark/arkservice/emailTemplate/getContent', { params })
}

// 获取流程卡片信息 /knowledge/knowledge/v3/ark/getDetail
export function fetchGetKnowledgeDetail(params) {
    return axiosInstance.get('/knowledge/knowledge/v3/ark/getDetail', { params })
}

// 知识库反馈提交
export function fetchFeedbackAdd(params) {
    return axiosInstance.post('/knowledge/knowledge/v3/comment/add', params)
}

// 异步消息tab开关
export function getAsyncMsgsABMethod(params, key) {
    // let url = '/ark/apollo/getApolloAbTestGroupNameByKeyPlus?grayKey=' + key
    let url = '/ark/arkservice/apollo/getApolloAbTestGroupNameByKeyPlus?grayKey=' + key
    return axiosInstance.post(url, params)
}

// clipper detail 查看
export function getClipperTicketStatus(params) {
    return axiosInstance.get('/ark/common/getClipperTicketStatus', { params })
    // return Promise.resolve(
    //     {
    //         "status": 0,
    //         "data": {
    //             "SLA_L2_firstClaimDate": 1628152182603,
    //             "aggressor": null,
    //             "SLA_L3_firstClaimDate": 0,
    //             "SLA_L3_closeDate": 0,
    //             "crmTid": "360287970462373109",
    //             "SLA_L2_closeDate": 0,
    //             "victim": null,
    //             "id": 7876214,
    //             "creationDate": 1628152110886,
    //             "category": [
    //                 "SUDDEN_DISEASE"
    //             ],
    //             "status": "T2 Claimed"
    //         },
    //         "error": null,
    //         "errors": null
    //     }
    // )
}

/* 流转 */
// 流转工单组列表
export function fetchGetGroupWithTargetGroupsById(params) {
    return axiosInstance.get('/ark/arkservice/group/getGroupWithTargetGroupsById', { params })
}

// 优先处理人列表
export function fetchGetGroupUsers(params) {
    return axiosInstance.get('/ark/arkservice/group/getGroupUsers', { params })
}

// 生成工单ID
export function fetchGenerateId(params) {
    return axiosInstance.get('/ark/arkservice/ticket/generateId', { params })
}

// 获取当前utc时间
export function fetchGetUtcTime(params) {
    return axiosInstance.get('/ark/arkservice/ticket/getUtcTime', { params })
}

// 是否有关单权限
export function fetchGetCloseTicketControlStatus(params) {
    return axiosInstance.get('/ark/arkservice/common/getCloseTicketControlStatus', { params })
}

// 工单回复记录
export function getTicketProcessDetailById(params) {
    return axiosInstance.get('/ark/arkservice/ticket/findTicketProcessDetailById', { params })
}

// 获取会话记录
export function getSessionListByTicketId (params) {
    return axiosInstance.get('/im-web/session/getSessionListByTicketId', { params })
}

// 保存工单  
export function fetchSaveTicket(params) {
    return axiosInstance.post('/ark/arkservice/ticket/saveTicket', params)
}

// 发送电子邮件  
export function fetchOuterReply(params) {
    return axiosInstance.post('/ark/arkservice/ticket/outerReply', params)
}

// 流转  
export function fetchEscalateTicket(params) {
    return axiosInstance.post('/ark/arkservice/ticket/escalateTicket', params)
}

// 流转  
export function fetchCloseTicket(params) {
    return axiosInstance.post('/ark/arkservice/ticket/closeTicket', params)
}

// 异步消息  
export function fetchSubmitTicket(params, key = 'kefu_async_msg') {
    let url = '/ark/arkservice/ticket/submitTicket?action=' + key
    return axiosInstance.post(url, params)
}

// 领取工单
export function fetchAssignTicketById(params) {
    return axiosInstance.get('/ark/arkservice/ticket/assignTicketById', { params })
}

// 回退工单
export function fetchReturnTicketById(params) {
    return axiosInstance.get('/ark/arkservice/ticket/returnTicketById', { params })
}

// email/cpf 获取电话号号码
export function getUidCommon(params) {
    return axiosInstance.get('/ark/arkservice/common/getUidCommon', { params })
}
// 获取sop配置
export function fetchArkManualSopConfig(params) {
    return axiosInstance.get('/ark/apollo/getArkManualSopConfig', { params })
}

// 异步消息  
export function fetchSubmitSopTicket(params, key = 'system_pre_save') {
    let url = '/ark/arkservice/ticket/submitTicket?action=' + key
    return axiosInstance.post(url, params)
}
export function getCountryTimezoneNew() {
    return axiosInstance.get('/global/getCountryTimezoneNew');
}
// 查看指定CR下的标签树结构
export function fetchListTagsTree(params) {
    return axiosInstance.get('/ark/arkservice/tag/listTagsTree',{params});
}

// 查看某个标签（list类型）的所有子标签列表
export function fetchListChildTags(params) {
    return axiosInstance.get('/ark/arkservice/tag/listChildTags',{params});
}

// 获取会话列表
export function requestCallList(params) {
    return axiosInstance.get('/gdata/arkservice/report/getConversationHistory', {params})
}

// 获取会话列表灰度
export function getGrayPermission (params) {
    return axiosInstance.get(`/ark/arkservice/apollo/getGrayPermission`, {params})
}

// 获取默认邮件标题，新版工作台用
export function fetchGetDefaultSubject (params = {}) {
    return axiosInstance.get(`/ark/arkservice/emailSettings/getDefaultSubject`, {params})
}
// 会话绑定工单接口 /im-web/session/bindTicket

export function fetchBindTicket(params) {
    return axiosInstance.post('/im-web/session/bindTicket', params)
}

// 获取推荐CR接口 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=893272561
export function fetchListRecommendCategory(params) {
    return axiosInstance.get('/ark/arkservice/localCategory/listRecommendCategory', {params})
}

// 智能摘要推荐列表
export function getAbstractRecommend(params) {
    return axiosInstance.post('/ark/arkservice/common/getAbstractRecommend', params)
}

// 异步工作台弹窗获取客服下一个待处理的工单 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=926037880
export function fetchWaitingTicketForAgent(params) {
    return axiosInstance.get('/ark/arkservice/ticket/getWaitingTicketForAgent', {params})
}